(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Plotly"), require("bootstrap"), require("io"), require("jQuery"), require("msal"));
	else if(typeof define === 'function' && define.amd)
		define(["Plotly", "bootstrap", "io", "jQuery", "msal"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("Plotly"), require("bootstrap"), require("io"), require("jQuery"), require("msal")) : factory(root["Plotly"], root["bootstrap"], root["io"], root["jQuery"], root["msal"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE__2104__, __WEBPACK_EXTERNAL_MODULE__9814__, __WEBPACK_EXTERNAL_MODULE__4676__, __WEBPACK_EXTERNAL_MODULE__4786__, __WEBPACK_EXTERNAL_MODULE__6369__) {
return 